import { createStyles } from '@mantine/core';
import themeVariables from '@/styles/themeVariables';

export const useSearchPageStyle = createStyles((theme, dark: any) => ({
  searchInput: {
    height: '60px !important',
    border: `1px solid ${themeVariables.lineDark.light200(dark?.dark)}`,
    borderRadius: '42px',
    fontSize: 21,
    fontWeight: 600,
    boxShadow: themeVariables.boxShadow.lightShadow,
    ':focus': {
      boxShadow: themeVariables.boxShadow.cardShadow,
    },
    backgroundColor: themeVariables.darkMode.bgDark(dark?.dark),
    padding: '25px 0',
    color: themeVariables.darkMode.normal(dark?.dark),
    [theme.fn.smallerThan('sm')]: {
      fontSize: 18,
      height: '52px !important',
    },
  },

  searchInputRightSection: {
    width: 140,
    [theme.fn.smallerThan('sm')]: {
      width: 60,
    },
  },

  searchInputKbd: {
    cursor: 'pointer',
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },

  resultTabItem: {
    border: `1px solid ${themeVariables.lineDark.light200(dark?.dark)}`,
    boxShadow: themeVariables.boxShadow.lightShadow,
    backgroundColor: themeVariables.colors.white,
    '> div': {
      borderColor: `${themeVariables.lineDark.light200(dark?.dark)} !important`,
    },
    '> div > label': {
      padding: '12px 21px',
      fontWeight: 700,
      color: themeVariables.darkMode.normal(dark?.dark),
      ':hover': {
        color: themeVariables.darkMode.alternative(dark?.dark),
      },
    },
    margin: '40px 0',
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },

  resultTabActiveItem: {
    borderWidth: '0px !important',
  },

  contentContainer: {
    marginTop: 20,
    [theme.fn.smallerThan('sm')]: {
      marginTop: 0,
    },
  },

  mobileTab: {
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
    width: '100%',
    flexWrap: 'wrap',
    padding: '24px 5px 25px',
    alignItems: 'center',
    justifyContent: 'center',
  },

  mobileTabNormalItem: {
    backgroundColor: themeVariables.colors.white,
    color: themeVariables.fontColors.light,
    border: `1px solid ${themeVariables.lineDark.light200(dark?.dark)}`,
    ':hover': {
      backgroundColor: themeVariables.colors.blue200,
      color: themeVariables.colors.white,
    },
  },

  mobileTabSelectedItem: {
    backgroundColor: themeVariables.colors.blue200,
    color: themeVariables.colors.white,
    ':hover': {
      backgroundColor: theme.colors.blue[6],
    },
  },

  mobileTabDisabledItem: {
    backgroundColor: themeVariables.colors.light200,
    color: themeVariables.colors.light500,
  },

  controls: {
    display: 'none',
  },
}));
